/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { SapHanaInstance } from '../models/SapHanaInstance';

/**
* Properties of a GCP SAP HANA VM resource. Present only when `resourceType` is set to `GCP_SAP_HANA_VM`. 
*/
export class GcpSapHanaResource {
  /**
  * List of SAP HANA instances on this VM.
  */
  'instances'?: Array<SapHanaInstance>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "instances",
      "baseName": "instances",
      "type": "Array<SapHanaInstance>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return GcpSapHanaResource.attributeTypeMap;
  }

  public constructor() {
  }
}

